export interface MaterialIconOption {
  label: string;
  value: string;
}

const toTitle = (name: string): string =>
  name
    .split("_")
    .map((w) => (w[0] ? w[0].toUpperCase() + w.slice(1) : w))
    .join(" ");

/**
 * @description Fetch Material Symbols metadata and return options for selects
 * @returns {Promise<MaterialIconOption[]>} Material icon options
 */
export const fetchMaterialIconOptions = async (): Promise<MaterialIconOption[]> => {
  // Always use a local curated list (no network) to avoid CORS and proxy dependencies
  const localIconNames: string[] = [
    // Confirmation & Completion
    "send",
    "done",
    "check_circle",
    "task_alt",
    "checklist",
    "forward_to_inbox",
    // E-Commerce & Payments
    "shopping_cart",
    "shopping_bag",
    "add_shopping_cart",
    "payment",
    "credit_card",
    "account_balance_wallet",
    "payments",
    "monetization_on",
    "attach_money",
    "currency_exchange",
    "receipt_long",
    "request_quote",
    // Forms, Uploads & Docs
    "description",
    "note_add",
    "upload_file",
    "cloud_upload",
    "file_upload_off",
    "file_present",
    "archive",
    "fact_check",
    "content_paste",
    "content_copy",
    // Communication & Messaging
    "mail",
    "email",
    "outgoing_mail",
    "sms",
    "chat",
    "forum",
    "support_agent",
    // Workflow & Approval
    "approval",
    "rule",
    "verified",
    "verified_user",
    "how_to_reg",
    "person_add",
    "done_all",
    // Navigation Actions (Next/Finish)
    "arrow_forward",
    "chevron_right",
    "double_arrow",
    "arrow_circle_right",
    "east",
    "done_outline",
    "exit_to_app",
    // Bookings & Reservations
    "event_available",
    "event_note",
    "calendar_month",
    "book_online",
    "local_activity",
    "local_offer",
    // Authentication & Security
    "lock",
    "login",
    "logout",
    "fingerprint",
    "key",
    // Special Case Actions
    "publish",
    "rocket_launch",
    "send_and_archive",
    "campaign",
    "share",
    "visibility",
    "download_done",
  ];

  const options = localIconNames.map((n) => ({ label: toTitle(n), value: n }));

  return options;
};
